$.fn.extend({
	triggerAll: function (events, params) {
		var el = this, i, evts = events.split(',');
		for (i = 0; i < evts.length; i += 1) {
			el.trigger(evts[i].trim(), params);
		}
		return el;
	}
});